import './ContactForm.scss';
import Component from './ContactForm.js';
export default Component;
